import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioModule } from '@vg-constellation/angular-19/radio';

interface Recipient {
  id: string;
  name: string;
  address: string;
  addressPurposeDescription?: string;
}

@Component({
  selector: 'app-recipient-radio-list',
  templateUrl: './recipient-radio-list.component.html',
  styleUrls: ['./recipient-radio-list.component.scss'],
  standalone: true,
  imports: [CommonModule, RadioModule]
})
export class RecipientRadioListComponent {
  @Input() recipients: Recipient[] = [];

  // Two-way binding support
  @Input() selectedRecipientKey: string = '';
  @Output() selectedRecipientKeyChange = new EventEmitter<string>();

  // Custom event for selection change
  @Output() selectionChanged = new EventEmitter<string>();


  /**
   * Called when a recipient is selected.
   * Emits both the two-way binding event and the custom event.
   */
  onRecipientChange(newValue: string): void {
    this.selectedRecipientKey = newValue;
    this.selectedRecipientKeyChange.emit(newValue);
    this.selectionChanged.emit(newValue);
  }

  /**
   * Used for ngFor trackBy to optimize rendering.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  trackByRecipient(index: number, recipient: Recipient): string {
    return recipient.id;
  }
}